<div class="container patient-details-page">
  <div class="page-header">
    <div class="patient-identity">
      <div class="patient-avatar" aria-hidden="true">{{ patientInitials }}</div>
      <div class="patient-heading">
        <div class="patient-title-row">
          <h1 class="patient-name">{{ patient?.first_name }} {{ patient?.last_name }}</h1>
          @if (patient?.patient_number) {
            <span class="patient-number">{{ patient.patient_number }}</span>
          }
        </div>
        <div class="patient-meta">
          @if (patient?.gender) {
            <span class="meta-chip">{{ patient.gender }}</span>
          }
          @if (patient?.age) {
            <span class="meta-chip">{{ patient.age }} years</span>
          }
          @if (patient?.birth_date) {
            <span class="meta-chip">Born {{ patient.birth_date | date: 'dd MMM yyyy' }}</span>
          }
        </div>
      </div>
    </div>
    <div class="header-actions">
      <button type="button" class="btn btn-brand" (click)="open(contentFiles)">Add files</button>
      <a [routerLink]="['/invoices']" [queryParams]="{id: patient?.id}" class="btn btn-outline-brand">Invoices</a>
      <a [routerLink]="['/appointments']" [queryParams]="{patient: patient?.id}" class="btn btn-outline-brand">Appointments</a>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-md-5">
      <div class="card details-card">
        <div class="card-header">Patient Details</div>
        <div class="card-body p-0">
          <dl class="details-list">
            <div class="detail-row">
              <dt>Email</dt>
              <dd>{{ patient?.email || '—' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Phone</dt>
              <dd>{{ patient?.phone || '—' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Secondary Phone</dt>
              <dd>{{ patient?.phone2 || '—' }}</dd>
            </div>
            <div class="detail-row">
              <dt>National ID</dt>
              <dd>{{ patient?.national_id || '—' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Address</dt>
              <dd>{{ patient?.address || '—' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Occupation</dt>
              <dd>{{ patient?.visiting_reason || '—' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Registered</dt>
              <dd>{{ patient?.created_at ? (patient.created_at | date: 'dd MMM yyyy') : '—' }}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>

    <div class="col-md-7">
      <div class="card details-card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span>Patient Files</span>
          <span class="count-badge">{{ filesCount }}</span>
        </div>
        <div class="card-body p-0">
          @if (filesCount === 0) {
            <div class="empty-state">
              <p class="empty-title">No files uploaded</p>
              <p class="empty-text">Add documents, reports, or contract copies for this patient.</p>
              <button type="button" class="btn btn-brand btn-sm" (click)="open(contentFiles)">Add files</button>
            </div>
          } @else {
            <div class="table-responsive">
              <table class="table details-table mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>File</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (f of pagedFiles; track f.id; let i = $index) {
                    <tr>
                      <td>{{ ((page_f - 1) * pageSize_f) + i + 1 }}</td>
                      <td>
                        <a [href]="f.file.file" target="_blank" rel="noopener noreferrer" class="file-link">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-file-earmark-text file-icon" viewBox="0 0 16 16">
                            <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" />
                            <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                          </svg>
                          {{ getFileName(f.file.file) }}
                        </a>
                      </td>
                      <td class="actions-cell">
                        <button [disabled]="!utility.isAllowed(['admin', 'accountant', 'doctor'])"
                          type="button" class="btn btn-sm btn-outline-danger" (click)="onDelete(f.id)"
                          aria-label="Delete file">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path fill-rule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (filesCount > pageSize_f) {
              <div class="table-footer">
                <ngb-pagination [collectionSize]="filesCount" [(page)]="page_f" [pageSize]="pageSize_f"
                  [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="false">
                </ngb-pagination>
              </div>
            }
          }
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="card details-card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span>Package Subscriptions</span>
          <span class="count-badge">{{ packages.length }}</span>
        </div>
        <div class="card-body p-0">
          @if (packages.length === 0) {
            <div class="empty-state">
              <p class="empty-title">No package subscriptions</p>
              <p class="empty-text">This patient does not have an active or past package yet.</p>
            </div>
          } @else {
            <div class="table-responsive">
              <table class="table details-table mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Service</th>
                    <th>Sessions</th>
                    <th>Left</th>
                    <th>Taken</th>
                    <th>Price</th>
                    <th>Paid</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of packages | slice: (page_d-1) * pageSize_d : (page_d-1) * pageSize_d + pageSize_d; track item; let i = $index) {
                    <tr>
                      <td>{{ ((page_d - 1) * pageSize_d) + i + 1 }}</td>
                      <td class="service-cell">{{ item.service_name }}</td>
                      <td>
                        <div class="session-cell">
                          <span>{{ item.no_sessions }}</span>
                          <div class="session-bar" aria-hidden="true">
                            <div class="session-bar-fill" [style.width.%]="sessionProgress(item)"></div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span class="sessions-left" [class.sessions-left--empty]="item.no_sessions_left == 0">
                          {{ item.no_sessions_left }}
                        </span>
                      </td>
                      <td>{{ item.no_sessions_took }}</td>
                      <td>{{ item.full_price }}</td>
                      <td>{{ item.paied_amount }}</td>
                      <td>{{ item.created_at | date: 'dd MMM yyyy' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (packages.length > pageSize_d) {
              <div class="table-footer">
                <ngb-pagination [collectionSize]="packages.length" [(page)]="page_d" [pageSize]="pageSize_d"
                  [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="false">
                </ngb-pagination>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #contentAppointment let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">New Appointment</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="doctor_id" class="form-label">Clinician</label>
          <select class="form-select" [(ngModel)]="appointment.doctor_id" (change)="getDoctorSlots()">
            <option [ngValue]="null">-- SELECT --</option>
            @for (doctor of doctors; track doctor) {
              <option [ngValue]='doctor.id'>{{ doctor.name }}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="date" class="form-label">Date</label>
          <input type="datetime-local" class="form-control" id="date" [(ngModel)]="appointment.date"
            [disabled]="appointment.doctor_id==null">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="form-label">Clinician Booked Slots</label>
          <div class="card">
            <div class="card-body table-wrapper">
              <table class="table">
                <tr>
                  <td>date</td>
                  <td colspan="2">time</td>
                </tr>
                @for (slot of dateSelection(slots); track slot) {
                  <tr>
                    <td>{{slot.date_time | date:'dd/MM/yyyy'}}</td>
                    <td>{{slot.date_time | date:'hh:mm a'}}</td>
                    <td>{{slot.date_time_to | date:'hh:mm a'}}</td>
                  </tr>
                }
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="service" class="form-label">Type of Service</label>
          <select class="form-select" [(ngModel)]="appointment.service" (change)="getPrice()"
            [disabled]="appointment.patient_id==null">
            <option [ngValue]="null">-- SELECT SERVICE --</option>
            @for (service of services; track service) {
              <option [ngValue]='service.id'>{{ service.name }}
              </option>
            }
          </select>
        </div>
        <div class="col">
          <label for="price" class="form-label">Price</label>
          <input type="number" class="form-control" [(ngModel)]="appointment.price" id="price" disabled>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="period" class="form-label">Appointment Period</label>
          <div class="input-group">
            <input type="number" class="form-control" id="period" min="1" step="1"
              [(ngModel)]="appointment.period" placeholder="e.g. 25">
            <span class="input-group-text">minutes</span>
          </div>
        </div>
        <div class="col">
          <label for="period" class="form-label">- -</label>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="walkin" [(ngModel)]="appointment.walkin">
            <label class="form-check-label" for="walkin">Walk-in</label>
          </div>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="overbooked"
              [(ngModel)]="appointment.overbooked">
            <label class="form-check-label" for="overbooked">Over booked</label>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="notes" class="form-label">Notes</label>
        <textarea class="form-control" [(ngModel)]="appointment.notes" id="notes" rows="2" cols="50"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="createAppointment(contentPackage)"
    [disabled]="appointment.service==''">Add</button>
  </div>
</ng-template>
<ng-template #contentFiles let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload Patient Files</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="mb-3">
        <label for="patinet_files" class="form-label">Contract Copy</label>
        <input type="text" class="form-control" [(ngModel)]="files" id="patinet_files" hidden>
        <input type="file" class="form-control" id="file" (change)="fileChange($event)">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="submit()">Submit</button>
  </div>
</ng-template>
<ng-template #contentPackage let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Select Package</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <p><b>Please Select Package type for payment if the payment is based on Installment, otherwise
          select No Package.</b></p>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="gender" class="form-label">Package Type</label>
          <select class="form-select" [(ngModel)]="package.package_id" (change)="onChangePackage()">
            <option [ngValue]="null">-- No Package --</option>
            @for (package of packages_all; track package) {
              <option [ngValue]='package.id'>{{ package.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="price" class="form-label">Number of Sessions</label>
        <input type="text" class="form-control" [(ngModel)]="package.no_sessions" id="price" disabled>
      </div>
      <div class="col">
        <label for="price" class="form-label">Price per Session</label>
        <input type="text" class="form-control" [(ngModel)]="package.session_price" id="price" disabled>
      </div>
      <div class="col">
        <label for="price" class="form-label">Total</label>
        <input type="text" class="form-control" [ngModel]="package.no_sessions * +package.session_price"
          id="price" disabled>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="OnSumbitPackage()">Confirm</button>
  </div>
</ng-template>
